import _ from 'lodash'

export const getAllAnswers = (state) => _.get(state, 'answers.answers', [])
export const getAnswersTotalCount = (state) => _.get(state, 'answers.totalCount', 0)
